/** @jsxImportSource @emotion/react */

import { Icon, Tooltip, TooltipProps, Typography } from "@a_team/ui-components";
import { SortConfig } from "components/Collaborators/CollaboratorTable";
import LoadingFallback from "components/LoadingFallback";

export interface CollaboratorTableCellProps {
  style?: any;
  name: string;
  saving?: boolean;
  sortable?: boolean;
  sorted?: boolean;
  sortConfig?: SortConfig;
  tooltip?: TooltipProps;
  onSort?: () => void;
}

export const TableCellHeader = (props: CollaboratorTableCellProps) => {
  const { onSort, style, sortable, sorted, name, sortConfig, saving, tooltip } =
    props;

  return (
    <div
      css={style}
      onClick={sortable ? onSort : undefined}
      style={{ cursor: sortable ? "pointer" : "default" }}
    >
      <Typography
        variant="textSmall"
        weight="regular"
        component="div"
        style={{ position: "relative", display: "flex", alignItems: "center" }}
      >
        {name}
        {tooltip && <Tooltip {...tooltip} />}
        {sorted && (
          <Icon
            size="sm"
            name={
              sortConfig?.direction === "desc" ? "arrowExpand" : "arrowCollapse"
            }
            style={{
              marginLeft: 2,
              marginBottom: 2,
              verticalAlign: "middle",
            }}
          />
        )}
      </Typography>
      {saving && (
        <LoadingFallback
          style={{
            height: 0,
            paddingLeft: 10,
            overflow: "visible",
            transform: "scale(0.8)",
          }}
        />
      )}
    </div>
  );
};
